import React from 'react'
import './Nav.css'

const Nav = () => {
    return (
        <nav className="nav">
            <h2>Global Covid Tracker</h2>
        </nav>
    )
}

export default Nav
